var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DefaultTemplate',[_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',{staticClass:"pt-0 pb-0",attrs:{"cols":"12"}},[_c('nuxt')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }